import { render, staticRenderFns } from "./UTags.vue?vue&type=template&id=bb2973fe"
import script from "./UTags.vue?vue&type=script&lang=js"
export * from "./UTags.vue?vue&type=script&lang=js"
import style0 from "./UTags.vue?vue&type=style&index=0&id=bb2973fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports